import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom'

import { SettingsContext } from '../contexts/index.jsx';
import { Alert, Verification } from "../components"
import { useMerchantStripe } from '../merchants';

const VerifyEmail = ({ authentication }) => {
  const { isRetailCircle, iframeQueryParams } = useContext(SettingsContext);
  const { goToStripeManagementPage } = useMerchantStripe();
  const [user, setUser] = useState();
  const [token, setToken] = useState();

  const onSubmit = (data) => {
    if (!isRetailCircle) {
      authentication.login(data.user, data.token, false)
    }

    setUser(data.user);
    setToken(data.token);
  }

  const accountLink = isRetailCircle ? (
    <a onClick={() => goToStripeManagementPage(user, token, false, true)} style={{ cursor: 'pointer' }}>account</a>
  ) : (
    <Link to={`/?${iframeQueryParams}`}>account</Link>
  )

  return (
    <Verification onSubmit={onSubmit}>
      <Alert
        type="success"
        message={
          isRetailCircle
            ? "Email verified! Login to subscribe"
            : "Email verified!"
        }
        description={<>Go to your {accountLink}.</>}
      />
    </Verification>
  )
};

export default VerifyEmail
